import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  constructor() { }

  decodeToken(token: string): string {
    // @ts-ignore
    return jwtDecode(token);
  }

  /**
   * Expiry of an access token as an ISO string, read from its `exp` claim. `/api/Auth/login` does
   * not return `expirationTokenDate` the way `/api/Auth/refresh` does, so the token itself is the
   * only source for it after signing in.
   */
  getExpirationDate(token: string): string | null {
    try {
      const exp = this.decodeToken(token)?.['exp'];
      if (typeof exp !== 'number' || !Number.isFinite(exp)) {
        return null;
      }
      return new Date(exp * 1000).toISOString();
    } catch {
      return null;
    }
  }
}
